import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Row, ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Image from '../../../shared/components/Image';
import { PRACTICAL_APP_OVERLAYS } from '../../../shared/Constants';

const UserCollectionCardDisplay = (props) => {
    const {
        collectionId,
        segmentEventHandler,
        imageProps: {
            imageSource,
            cloudinaryCrop,
            dimension,
            textProp,
            overlay,
            completionPercentage,
            showProgressBar
        },
        cardOrientation,
        className = 'col-12 col-sm-6',
        isReadOnly = false,
        footer = null,
        cardHeadingProps: { text, headingClass },
        subtitle = '',
        title = '',
        link = null,
        actionButton = null,
        cardNumber,
        subtitleHeight,
        subtitleLines,
        hideDetailsOverlay = false,
        overlayMode = ''
    } = props;

    let cardWithoutLink;

    if (cardOrientation === 'vertical') {
        cardWithoutLink = (
            <Row className={'collection-card-container'}>
                <div className={'col-12 collection-display'}>
                    <div className={'collection-image-display'}>
                        {showProgressBar && (
                            <ProgressBar
                                key={collectionId}
                                now={completionPercentage}
                                className={'user-collection-card-progress-bar'}
                            />
                        )}
                        <Image
                            src={imageSource}
                            dimension={dimension}
                            cloudinaryCrop={cloudinaryCrop}
                            textProp={textProp}
                            overlay={overlay}
                            className={'trackCardImage'}
                        />
                    </div>
                    {!hideDetailsOverlay ? <h4 className={'col-12 collection-title'}>{title}</h4> : null}
                </div>
                {!hideDetailsOverlay ? (
                    <div className={'col-12 collection-details'}>
                        <div className={'collection-details-background'}>
                            {text && <h6 className={cns('collection-type col-12', headingClass)}>{text}</h6>}
                            <h4 className={'col-12'}>{title}</h4>
                            <small className={'col-12 collection-subtitle'}>{subtitle}</small>
                            {footer}
                        </div>
                    </div>
                ) : null}
            </Row>
        );
    } else {
        cardWithoutLink = (
            <Row className={'collection-container'}>
                <div className={`col-5 asset-left-display user-collection-asset-left-display-${cardNumber}`}>
                    <div className={'collection-image-display'}>
                        {showProgressBar && (
                            <ProgressBar
                                key={collectionId}
                                now={completionPercentage}
                                className={'user-collection-card-progress-bar'}
                            />
                        )}
                        <Image
                            src={imageSource}
                            dimension={dimension}
                            cloudinaryCrop={cloudinaryCrop}
                            textProp={textProp}
                            overlay={overlay}
                            className={'trackCardImage'}
                        />
                    </div>
                </div>
                {!hideDetailsOverlay ? (
                    <div className={'col-7 collection-details'}>
                        <h6 className={cns('collection-type', headingClass)}>{text}</h6>
                        <h4 className={`collection-title user-collection-card-title-${cardNumber}`}>{title}</h4>
                        <div className={cns('collection-subtitle-container hidden-sm hidden-xs')}>
                            <small
                                className={`collection-subtitle user-collection-card-subtitle-${cardNumber}`}
                            >
                                {subtitle}
                            </small>
                        </div>
                        {footer}
                    </div>
                ) : null}
            </Row>
        );
    }

    return (
        <div
            key={collectionId}
            className={cns(
                cardOrientation === 'vertical' ? 'vertical-collection-card' : 'user-collection-card',
                className,
                {
                    'read-only': isReadOnly
                }
            )}
            onClick={segmentEventHandler}
        >
            {!isReadOnly ? (
                <Link className={'card-link'} to={link}>
                    {cardWithoutLink}
                </Link>
            ) : (
                cardWithoutLink
            )}
            {cardOrientation === 'vertical' && actionButton ? (
                <div className={'row collection-action-buttons col-12'}>{actionButton}</div>
            ) : null}
        </div>
    );
};

UserCollectionCardDisplay.propTypes = {
    cardOrientation: PropTypes.oneOf(['vertical', 'horizontal']),
    className: PropTypes.string,
    collectionId: PropTypes.string,
    isReadOnly: PropTypes.bool,
    link: PropTypes.string,
    segmentEventHandler: PropTypes.func,
    cardHeadingProps: PropTypes.shape({
        text: PropTypes.string,
        headingClass: PropTypes.string
    }),
    imageProps: PropTypes.shape({
        imageSource: PropTypes.string,
        cloudinaryCrop: PropTypes.string,
        dimension: PropTypes.object,
        textProp: PropTypes.object,
        overlay: PropTypes.object,
        showProgressBar: PropTypes.bool,
        completionPercentage: PropTypes.number
    }),
    title: PropTypes.string,
    subtitle: PropTypes.string,
    footer: PropTypes.object,
    actionButton: PropTypes.object,
    cardNumber: PropTypes.number,
    subtitleHeight: PropTypes.number,
    subtitleLines: PropTypes.number,
    hideDetailsOverlay: PropTypes.bool,
    overlayMode: PropTypes.string
};

export default UserCollectionCardDisplay;
